module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.showShop) ? _c('span', [_vm._v("\n      分店："), _c('el-select', {
    staticClass: "w150 mr20",
    attrs: {
      "clearable": "",
      "placeholder": "请选择分店"
    },
    model: {
      value: (_vm.params.shopNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "shopNum", $$v)
      },
      expression: "params.shopNum"
    }
  }, _vm._l((this.shopList), function(item) {
    return _c('el-option', {
      key: item.shopNum,
      attrs: {
        "label": item.name,
        "value": item.shopNum
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v("\n      票名："), _c('el-input', {
    staticClass: "w150 mr20",
    attrs: {
      "placeholder": "请输入票名",
      "clearable": ""
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.queryList()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog()
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "票信息",
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [(_vm.addType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "票类型",
      "prop": "typeId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.typeId),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "typeId", $$v)
      },
      expression: "formparams.typeId"
    }
  }, _vm._l((this.options), function(item) {
    return _c('el-option', {
      key: item.tid,
      attrs: {
        "label": item.ticketType,
        "value": item.tid
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "票名称",
      "prop": "ticketName"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入票明",
      "maxlength": "20"
    },
    model: {
      value: (_vm.formparams.ticketName),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "ticketName", $$v)
      },
      expression: "formparams.ticketName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "上传票图",
      "required": ""
    }
  }, [_c('el-upload', {
    ref: "upload",
    class: {
      uploaderNone: _vm.hideUpload
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange,
      "on-remove": _vm.handleRemove,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v("\n            *提示*：为了更好的用户体验，图片请提供360*180像素，文件大小不超过500kb。\n          ")], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "票价",
      "prop": "price"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入票的价格"
    },
    model: {
      value: (_vm.formparams.price),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "price", $$v)
      },
      expression: "formparams.price"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否限制出售总量",
      "label-width": "180px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "是",
      "inactive-text": "否"
    },
    model: {
      value: (_vm.formparams.isreduce),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "isreduce", $$v)
      },
      expression: "formparams.isreduce"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.formparams.isreduce === '1') ? _c('el-form-item', {
    attrs: {
      "label": "出售总量",
      "prop": "number"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入出售总量"
    },
    model: {
      value: (_vm.formparams.number),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "number", _vm._n($$v))
      },
      expression: "formparams.number"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.formparams.validityTime == 0) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否限制购买数量",
      "label-width": "180px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "是",
      "inactive-text": "否"
    },
    model: {
      value: (_vm.formparams.isRestrictionSaleNum),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "isRestrictionSaleNum", $$v)
      },
      expression: "formparams.isRestrictionSaleNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(_vm.formparams.isRestrictionSaleNum === '1') ? _c('el-form-item', {
    attrs: {
      "label": "购买数量",
      "prop": "saleNum"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入购买数量"
    },
    model: {
      value: (_vm.formparams.saleNum),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "saleNum", _vm._n($$v))
      },
      expression: "formparams.saleNum"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "票说明",
      "prop": "subtitle"
    }
  }, [_c('editor-bar', {
    attrs: {
      "isClear": _vm.isClear
    },
    model: {
      value: (_vm.formparams.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "subtitle", $$v)
      },
      expression: "formparams.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分店",
      "prop": "shopNum"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.shopNum),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "shopNum", $$v)
      },
      expression: "formparams.shopNum"
    }
  }, _vm._l((this.shopList), function(item) {
    return _c('el-option', {
      key: item.shopNum,
      attrs: {
        "label": item.name,
        "value": item.shopNum
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "bigintime"
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '00:00',
        step: '00:30',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.formparams.bigintime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "bigintime", $$v)
      },
      expression: "formparams.bigintime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "endtime"
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '00:30',
        step: '00:30',
        end: '24:00',
        minTime: _vm.formparams.bigintime
      }
    },
    model: {
      value: (_vm.formparams.endtime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "endtime", $$v)
      },
      expression: "formparams.endtime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用时间"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.timeList),
      callback: function($$v) {
        _vm.timeList = $$v
      },
      expression: "timeList"
    }
  }, _vm._l((_vm.weekS), function(item, i) {
    return _c('el-checkbox', {
      key: i,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期",
      "prop": "validityTime"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "有效期0代表当天1代表明天",
      "maxlength": "20"
    },
    model: {
      value: (_vm.formparams.validityTime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "validityTime", _vm._n($$v))
      },
      expression: "formparams.validityTime"
    }
  }), _vm._v("(单位:天)\n          ")], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动方式"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.favorabletype),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "favorabletype", $$v)
      },
      expression: "formparams.favorabletype"
    }
  }, _vm._l((this.favorabletypeS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(_vm.formparams.favorabletype == 1 || _vm.formparams.favorabletype == '') ? _c('el-form-item', {
    attrs: {
      "label": "优惠折扣"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "maxlength": "3",
      "placeholder": "请输入折扣（1-100）"
    },
    model: {
      value: (_vm.formparams.activity),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "activity", _vm._n($$v))
      },
      expression: "formparams.activity"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formparams.favorabletype == 2) ? _c('el-form-item', {
    attrs: {
      "label": "票赠送"
    }
  }, [_vm._v("\n                买"), _c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.buyNum),
      callback: function($$v) {
        _vm.buyNum = $$v
      },
      expression: "buyNum"
    }
  }), _c('span', {
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_vm._v("/")]), _vm._v("赠送"), _c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.giveNum),
      callback: function($$v) {
        _vm.giveNum = $$v
      },
      expression: "giveNum"
    }
  }), _vm._v("(单位：个)\n              ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动开始/结束时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "default-time": ['00:00:00', '23:59:59'],
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "73vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "150",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "分店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm._f("caseType")(scope.row.shopnum)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "票图片",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "100px",
            "height": "50px"
          },
          attrs: {
            "src": 'http://zlesp.zlydgy.cn:8091/images/' + scope.row.picture,
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "width": "100",
      "label": "价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "width": "70",
      "label": "总数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "出售时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.ticketConfig && scope.row.ticketConfig.bigintime) ? [_vm._v("\n          " + _vm._s(scope.row.ticketConfig.bigintime) + " - " + _vm._s(scope.row.ticketConfig.endtime) + "\n        ")] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70",
      "label": "有效期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ticketConfig && scope.row.ticketConfig.validitytime && scope.row.ticketConfig.validitytime != 0) ? _c('span', [_vm._v(_vm._s(scope.row.ticketConfig.validitytime) + "天")]) : _c('span', [_vm._v("当天")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "使用时间",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ticketConfig) ? _c('span', [_vm._v(_vm._s(scope.row.ticketConfig.usetime))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "subtitle",
      "label": "票说明"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top",
            "width": "300px"
          }
        }, [_c('div', {
          staticClass: "menuTree",
          domProps: {
            "innerHTML": _vm._s(scope.row.subtitle)
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-tag', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("鼠标放上查看详情")])], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动类型",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.ticketConfig && scope.row.ticketConfig.favorabletype) ? [(scope.row.ticketConfig.favorabletype == 1) ? _c('div', [_vm._v("类型：折扣")]) : _vm._e(), _vm._v(" "), (scope.row.ticketConfig.favorabletype == 2) ? _c('div', [_vm._v("类型：赠送")]) : _vm._e(), _vm._v(" "), (scope.row.ticketConfig.favorabletype == 1) ? _c('div', [_vm._v("折扣优惠：" + _vm._s(scope.row.ticketConfig.activity) + "折")]) : _vm._e(), _vm._v(" "), (scope.row.ticketConfig.favorabletype == 2) ? _c('div', [_vm._v("折扣优惠：" + _vm._s(scope.row.ticketConfig.activity))]) : _vm._e(), _vm._v(" "), (scope.row.ticketConfig.activestarttime) ? _c('div', [_vm._v(" 开始时间：" + _vm._s(scope.row.ticketConfig.activestarttime))]) : _vm._e(), _vm._v(" "), (scope.row.ticketConfig.activeendtime) ? _c('div', [_vm._v(" 结束时间：" + _vm._s(scope.row.ticketConfig.activeendtime))]) : _vm._e()] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.type == 1),
            expression: "scope.row.type==1"
          }],
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeList(scope.row.id)
            }
          }
        }, [_vm._v("下架")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.type != 1),
            expression: "scope.row.type!=1"
          }],
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.addList(scope.row.id)
            }
          }
        }, [_vm._v("上架")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.gobackTicket(scope.row)
            }
          }
        }, [_vm._v("退款设置")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.goCardTicket(scope.row)
            }
          }
        }, [_vm._v("会员卡购票设置")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageination"
  }, [_c('el-col', [_c('el-pagination', {
    staticStyle: {
      "textAlign": "center",
      "marginTop": "10px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 40, 80, 100],
      "page-size": 20,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-282ba216"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/buyTicket/buyTicket.vue
// module id = 591
// module chunks = 70